import { memo, useContext } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { CallTopicContext } from '../../../contexts/CallTopicContext';
import CallTopicTag from './CallTopicTag';
import { jsx as _jsx } from "react/jsx-runtime";
const CallTopicsList = () => {
  const {
    callTopics
  } = useContext(CallTopicContext);
  const uniqueTopics = Array.from(new Set(callTopics.map(topicInstance => topicInstance.callTopicId)));
  if (callTopics.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    columnGap: "250",
    paddingBlockStart: "250",
    "data-test-id": "callTopic-list",
    marginBlockStart: "300",
    children: uniqueTopics.map(callTopic => {
      if (!callTopic) {
        return null;
      }
      return /*#__PURE__*/_jsx(CallTopicTag, {
        callTopic: callTopic
      }, callTopic);
    })
  });
};
export default /*#__PURE__*/memo(CallTopicsList);